import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { DatePicker, Flex, Input, Select, Typography } from "antd";
import { useState } from "react";
import {
  postTrainerPacket,
  trainersAction,
} from "src/store/Slices/Administrator/TrainersSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getClubs,
  getTrainerTypes,
  getTrainers,
} from "src/store/Slices/DropDownSlice";
import { useEffect } from "react";
import { setErrorNotAllFields } from "src/store/Slices/HelperSlice";
import dayjs from "dayjs";

const CreatePacketsModal = ({ visible, setVisible, setPage, setPageSize }) => {
  const dispatch = useDispatch();

  const [trainer, setTrainer] = useState("");
  const [to, setTo] = useState();
  const [from, setFrom] = useState();
  const [count, setCount] = useState([]);
  // const trainerTypes = useSelector((state) => state.DropDownSlice.trainerTypes);
  const trainers = useSelector((state) => state.DropDownSlice.trainersList);
  // const isBuyOptions = [
  //   { value: true, label: "Да" },
  //   { value: false, label: "Нет" },
  // ];
  useEffect(() => {
    dispatch(getTrainerTypes());
    dispatch(getClubs());
    dispatch(getTrainers());
    setCount("");
    setTrainer("");
    setFrom("");
    setTo("");
  }, [visible]);

  const onClickSubmit = () => {
    if (!(trainer && count)) {
      dispatch(setErrorNotAllFields());
    } else {
      let arr = count.trim().split(" ");
      dispatch(
        postTrainerPacket({
          value: {
            trainerId: trainer,
            trainingCounts: arr,
            buyableFrom: from ? dayjs(from).format("YYYY-MM-DD") : undefined,
            buyableTo: to ? dayjs(to).format("YYYY-MM-DD") : undefined,
          },
        })
      ).then((data) => {
        dispatch(trainersAction({ flag: "get" })).then(() => {
          !(data?.payload?.status === 400) && setVisible(false);
          setPage(1);
          setPageSize(20);
        });
      });
    }
  };

  return (
    <CModal
      alignment="center"
      visible={visible}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setVisible(false);
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">
          Добавить пакет тренировок
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Тренер</Typography.Title>
              <Select
                onClick={() => {
                  dispatch(getTrainers());
                }}
                style={{ width: "100%" }}
                value={trainer}
                onChange={(e) => setTrainer(e)}
                options={trainers?.data?.value}
              />
            </div>

            <div>
              <Typography.Title level={5}>
                Количество тренировок(Ввести числа через пробел)
              </Typography.Title>
              <Input
                value={count}
                onChange={(e) => setCount(e.currentTarget.value)}
              />
            </div>

            <div>
              <Typography.Title level={5}>Покупка с</Typography.Title>
              <DatePicker
                style={{ width: "100%" }}
                format={"YYYY-MM-DD"}
                placement={"topRight"}
                onChange={(date) => {
                  setFrom(date);
                }}
                value={from}
              />
            </div>
            <div>
              <Typography.Title level={5}>До</Typography.Title>
              <DatePicker
                style={{ width: "100%" }}
                format={"YYYY-MM-DD"}
                placement={"topRight"}
                onChange={(date) => {
                  setTo(date);
                }}
                value={to}
              />
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setVisible(false);
          }}
          className="text-light"
          color="secondary"
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickSubmit} className="text-light">
          Добавить
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default CreatePacketsModal;
